__turbopack_context__.v({
  "active": "SideNavLayout-module-scss-module__lxtc0q__active",
  "arowDown": "SideNavLayout-module-scss-module__lxtc0q__arowDown",
  "disableClick": "SideNavLayout-module-scss-module__lxtc0q__disableClick",
  "dropdownMenuItemClassName": "SideNavLayout-module-scss-module__lxtc0q__dropdownMenuItemClassName",
  "isSideBarExpanded": "SideNavLayout-module-scss-module__lxtc0q__isSideBarExpanded",
  "label": "SideNavLayout-module-scss-module__lxtc0q__label",
  "logoContainer": "SideNavLayout-module-scss-module__lxtc0q__logoContainer",
  "logoWrapper": "SideNavLayout-module-scss-module__lxtc0q__logoWrapper",
  "mainLayoutWrapper": "SideNavLayout-module-scss-module__lxtc0q__mainLayoutWrapper",
  "menuIcon": "SideNavLayout-module-scss-module__lxtc0q__menuIcon",
  "menuItem": "SideNavLayout-module-scss-module__lxtc0q__menuItem",
  "menuItemWrapper": "SideNavLayout-module-scss-module__lxtc0q__menuItemWrapper",
  "menuItems": "SideNavLayout-module-scss-module__lxtc0q__menuItems",
  "menuItemsWrapper": "SideNavLayout-module-scss-module__lxtc0q__menuItemsWrapper",
  "postingBtn": "SideNavLayout-module-scss-module__lxtc0q__postingBtn",
  "postingBtnContainer": "SideNavLayout-module-scss-module__lxtc0q__postingBtnContainer",
  "postingButtonWrapper": "SideNavLayout-module-scss-module__lxtc0q__postingButtonWrapper",
  "postingIconContainer": "SideNavLayout-module-scss-module__lxtc0q__postingIconContainer",
  "postingLabel": "SideNavLayout-module-scss-module__lxtc0q__postingLabel",
  "postingLabelContainer": "SideNavLayout-module-scss-module__lxtc0q__postingLabelContainer",
  "postingMenuDropdownContainer": "SideNavLayout-module-scss-module__lxtc0q__postingMenuDropdownContainer",
  "showSubmenu": "SideNavLayout-module-scss-module__lxtc0q__showSubmenu",
  "sideBarWrapper": "SideNavLayout-module-scss-module__lxtc0q__sideBarWrapper",
  "siteMainContent": "SideNavLayout-module-scss-module__lxtc0q__siteMainContent",
  "subMenuActive": "SideNavLayout-module-scss-module__lxtc0q__subMenuActive",
  "subMenuIcon": "SideNavLayout-module-scss-module__lxtc0q__subMenuIcon",
  "subMenuItem": "SideNavLayout-module-scss-module__lxtc0q__subMenuItem",
  "subMenuItems": "SideNavLayout-module-scss-module__lxtc0q__subMenuItems",
  "subMenuLabel": "SideNavLayout-module-scss-module__lxtc0q__subMenuLabel",
  "userProfileButtonWrapper": "SideNavLayout-module-scss-module__lxtc0q__userProfileButtonWrapper",
  "userProfileIconContainer": "SideNavLayout-module-scss-module__lxtc0q__userProfileIconContainer",
  "userProfileLabel": "SideNavLayout-module-scss-module__lxtc0q__userProfileLabel",
  "userProfileLabelContainer": "SideNavLayout-module-scss-module__lxtc0q__userProfileLabelContainer",
});
